import React, { forwardRef } from "react";
import { ReportDataConsumer } from "../services/report-data-service-provider";
import ErrorBoundary from "../components/error-boundary";

const withSignalServiceComponent = errorCaptionKey => Wrapped => {
    const ComponentWithSignalService = forwardRef((props, ref) => {
        return (
            <ErrorBoundary fillParent errorCaptionKey={errorCaptionKey}>
                <ReportDataConsumer>
                    {({ signalService }) => {
                        const { reqSignal, reqSignalThrottling } = signalService ?? {};
                        const serviceProps = {
                            reqSignal,
                            reqSignalThrottling
                        };
                        const prepared = signalService !== null && signalService !== undefined;
                        return <Wrapped {...props} signalService={signalService} prepared={prepared} {...serviceProps} ref={ref} />;
                    }}
                </ReportDataConsumer>
            </ErrorBoundary>
        );
    });

    return ComponentWithSignalService;
};
const errorCaptionKey = "errors.dataUnavailable";
const withReportDataService = Wrapped => withSignalServiceComponent(errorCaptionKey)(Wrapped);
export default withReportDataService;
